export const RESPOSTA_OPTIONS: { label: string; valor: string | null }[] = [
  { label: "Done", valor: "S" },
  { label: "Desc", valor: null },
  { label: "Block", valor: "N" },
  { label: "NA", valor: "NA" },
  { label: "Atenção", valor: "A" },
  { label: "I", valor: "I" },
  { label: "Regular", valor: "R" },
  { label: "Normal", valor: "NO" },
  { label: "Agendar Troca", valor: "AT" },
  { label: "Trocar", valor: "TR" },
];

export const descricaoToValor = (descricao: string | null) => {
  const found = RESPOSTA_OPTIONS.find((r) => r.label === descricao);
  return found ? found.valor : descricao;
};
